import {
    FaWhatsapp,
    FaInstagram,
    FaFacebook,
    FaTiktok,
    FaYoutube,
    FaGlobe,
} from "react-icons/fa";

export const itemsList = [
    {
        id: "whatsapp",
        href: "https://wa.me/905368758102",
        text: "WhatsApp",
        icon: FaWhatsapp,
        showInIcons: true,
        showInButtons: true,
    },
    {
        id: "website",
        href: "https://bilalabdulhadi.com",
        text: "Online Store",
        icon: FaGlobe,
        showInIcons: true,
        showInButtons: false,
    },
    {
        id: "instagram",
        href: "https://www.instagram.com/bilalabdulhadii",
        text: "Instagram",
        icon: FaInstagram,
        showInIcons: true,
        showInButtons: true,
    },
    {
        id: "facebook",
        href: "https://www.facebook.com/bilalabdulhadii",
        text: "Facebook",
        icon: FaFacebook,
        showInIcons: true,
        showInButtons: true,
    },
    {
        id: "tiktok",
        href: "https://www.tiktok.com/@bilalabdulhadii",
        text: "TikTok",
        icon: FaTiktok,
        showInIcons: true,
        showInButtons: true,
    },
    {
        id: "youtube",
        href: "https://www.youtube.com/@bilalabdulhadii",
        text: "YouTube",
        icon: FaYoutube,
        showInIcons: true,
        showInButtons: true,
    },
];
